import { FC, useMemo, useEffect, useState, PropsWithChildren } from 'react';
import classnames from 'classnames';

import * as Styles from './multiline-text.module.scss';

export interface MultilineTextProps extends PropsWithChildren {
    maxLines: number;
    height: string;
    className?: string;
    onLinesCalculated?: (isTruncated: boolean) => void;
}

export const MultilineText: FC<MultilineTextProps> = ({
    maxLines,
    children,
    height,
    className,
    onLinesCalculated,
}) => {
    const style = useMemo(() => {
        return {
            WebkitLineClamp: maxLines,
            height,
        };
    }, [height, maxLines]);

    const [text, setText] = useState<HTMLSpanElement | null>(null);

    useEffect(() => {
        if (text && !!onLinesCalculated) {
            if (text.scrollHeight > text.clientHeight) {
                onLinesCalculated(true);
            } else {
                onLinesCalculated(false);
            }
        }
    }, [onLinesCalculated, text]);

    return (
        <div
            className={classnames(Styles.lineClamp, className)}
            style={style}
            ref={(textRef: HTMLElement | null) => setText(textRef)}
        >
            {children}
        </div>
    );
};
